import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GaSidenavModule } from './sidenav/sidenav.module';

const COMPONENTS = [GaSidenavModule];

@NgModule({
    imports: [
        CommonModule,
        ...COMPONENTS
    ],
    exports: COMPONENTS
})
export class GaShellComponentsModule { }
